const settingsNorwegian = {
  header: {
    title: "LinkedIn Innstillinger",
    description: "Koble til LinkedIn-kontoen din for å få tilgang til systemet",
    descriptionEmployee: "Koble til kontoene dine for å komme i gang"
  },
  messages: {
    success: "Suksess!",
    error: "Det oppstod en feil",
    closeButton: "Lukk"
  },
  linkedin: {
    title: "LinkedIn Profil",
    loading: "Laster...",
    connected: "LinkedIn-profil tilkoblet",
    description: "Koble til LinkedIn-profilen din for å lage innlegg",
    connectButton: "Koble til LinkedIn",
    disconnectButton: "Koble fra LinkedIn",
    profileInfo: {
      unnamed: "Navnløs bruker",
      status: "Status:",
      active: "Aktiv",
      expires: "Utløper:",
      expiresIn: "Om {days} dager",
      unknown: "Ukjent",
      noProfileData: "Kunne ikke hente profildata. Prøv å koble fra og koble til igjen."
    }
  },
  telegram: {
    title: "Telegram Bot",
    description: "Koble til Telegram for å generere og motta LinkedIn-innlegg direkte",
    connected: "Telegram er tilkoblet",
    connectButton: "Koble til Telegram",
    disconnectButton: "Koble fra Telegram",
    generating: "Genererer kode...",
    connectionGuide: {
      title: "Slik kobler du til Telegram",
      steps: [
        "Åpne Telegram og søk etter NuvikAI_bot",
        "Start boten ved å skrive /start",
        "Send denne koden til boten:"
      ],
      expires: "Koden utløper om 15 minutter"
    }
  },
  deliverySettings: {
    title: "Leveringsinnstillinger",
    description: "Velg hvor du vil motta dine ukentlige AI-genererte LinkedIn-innlegg",
    options: {
      website: "På nettsiden",
      telegram: "Via Telegram"
    },
    helpText: {
      website: "Innleggene dine vil vises i \"LinkedIn AI Generator\"-delen av appen.",
      telegram: "Innleggene dine vil sendes direkte til deg via Telegram."
    }
  },
  readyCard: {
    title: "Alt er klart!",
    description: "Du kan nå bruke Telegram til å generere og publisere LinkedIn-innlegg, eller se dine genererte innlegg direkte i appen.",
    viewPostsButton: "Se innleggene dine"
  },
  customerSuccess: {
    title: "LinkedIn-konto tilkoblet!",
    description: "LinkedIn-kontoen din er nå tilkoblet. Du vil nå motta innhold fra systemet som vil bli delt på LinkedIn-profilen din."
  },
  language: {
    title: "Språk",
    description: "Velg ditt foretrukne språk"
  }
};

export default settingsNorwegian; 